/** Controle de permissões */
import Store from "../store";

/** Acordos */
export const ACORDO_CREATE = "acordo.acordo_create"; // Criar novos acordos
export const ACORDO_CREATE_ALL = "acordo.acordo_create_all"; // Criar novos acordos mesmo com acordo ativo já cadastrado
export const ACORDO_UPDATE = "acordo.acordo_update"; // Atualizar informações do acordo
export const ACORDO_DELETE = "acordo.acordo_delete"; // Deletar acordo
export const ACORDO_READ = "acordo.acordo_read"; // Permite visualizar acordos
export const ACORDO_READ_OTHERS = "acordo.acordo_read_others"; // Visualizar acordo de outros operadores
export const ACORDO_LIST_ALL = "acordo.acordo_list_all"; // Permite listar todos os acordos do sistema
export const ACORDO_CONF_TIPOS = "acordo.acordo_conf_tipos_acordo"; // Criar/editar/excluir tipos de acordo

/** Parcelas */
export const PARCELA_RECEBER = "acordo.parcela_receber"; // Permite receber/despagar parcelas
export const PARCELA_LISTAR = "acordo.parcela_listar"; // Acesso a listagem de parcelas
export const PARCELA_UPDATE = "acordo.parcela_update"; // Atualizar informações de parcelas

/** Pastas */
export const PASTA_CREATE = "pasta.pasta_create"; // Criar novas pastas
export const PASTA_UPDATE = "pasta.pasta_update"; // Atualizar informações de pastas
export const PASTA_DELETE = "pasta.pasta_delete"; // Excluir pastas
export const PASTA_READ = "pasta.pasta_read"; // Visualizar pastas
export const PASTA_LIST_ALL = "pasta.pasta_list_all"; // Listar todas as pastas do sistema

/** NFe Pipeline */
export const NFE_VIEWER = "nfe_pipeline.nfe_viewer"; // Permite visualizar e operar pipeline NFe

/** Verifica se o usuário possui determinada permissão */
export function has(permission) {
  const permissions = Store.getState().permissions.permissions;
  return permissions.find(perm => perm == permission);
}

/** Verifica se o usuário possui determinada permissão explicitamente */
export function hasExplicit(permission) {
  const explicit = Store.getState().permissions.explicit_permissions;
  if (explicit !== null && explicit !== undefined) {
    return explicit.find(perm => perm == permission);
  }
  return has(permission);
}



// WEBPACK FOOTER //
// ./src/services/permissions.js